module.exports = __webpack_public_path__ + "assets/loop-active.34277aff.svg";